import React, { Component } from 'react';

class ImageButton extends Component {
  componentDidMount() {
    const { id, handleClick } = this.props;
    this.el = document.getElementById(`${id}`);
    this.labelEl = document.getElementById(`${id}-label`);
    this.el.addEventListener('click', handleClick);
    if (this.labelEl) {
      this.el.addEventListener('mouseenter', () =>
        this.labelEl.setAttribute('visible', 'true')
      );
      this.el.addEventListener('mouseleave', () =>
        this.labelEl.setAttribute('visible', 'false')
      );
    }
  }
  componentWillUnmount() {
    const { id, handleClick } = this.props;
    this.el = document.getElementById(`${id}`);
    this.el.removeEventListener('click', handleClick);

    if (this.labelEl) {
      this.el.removeEventListener('mouseenter', () =>
        this.labelEl.setAttribute('visible', 'true')
      );
      this.el.removeEventListener('mouseleave', () =>
        this.labelEl.setAttribute('visible', 'false')
      );
    }
  }

  render() {
    const { id, src, height, label, width, position, dataCy } = this.props;
    const labelId = `${id}-label`;
    return (
      <a-entity position={position}>
        {label && (
          <a-text
            id={labelId}
            visible="false"
            align="center"
            position={`0 ${height / 2 + 0.2} 0`}
            value={label}
            font="https://cdn.aframe.io/fonts/Aileron-Semibold.fnt"
            data-cy={dataCy}
          />
        )}
        <a-image
          class="clickable"
          id={id}
          src={src}
          height={height}
          width={width}
        />
      </a-entity>
    );
  }
}

export default ImageButton;
